'use client';

import React from 'react';

const CheckIcon = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='mt-1 shrink-0'
  >
    <path
      d='M5 12.5L10 17.5L19.5 7'
      stroke='#0066FF'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const Grade = ({ className = '', title, subtitle, items }) => {
  return (
    <div className={className}>
      <div className='bg-white rounded-[30px] h-[92px] px-[22px] flex items-center mb-[22px]'>
        <h3 className='text-2xl font-oswald font-semibold text-black uppercase leading-[39px] max-w-[300px]'>
          <span className='font-bold'>{title}</span> {subtitle ? '— ' : ''}
          {subtitle && <span className='font-normal'>{subtitle}</span>}
        </h3>
      </div>

      <div className='space-y-4'>
        {items.map((item, i) => (
          <div className='flex items-start space-x-3' key={i}>
            <CheckIcon />
            <p className='text-lg font-montserrat text-white leading-[1.5]'>
              {item}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Grade;
